import Vue from 'vue'
import axios from 'axios'
// import Qs from 'qs'
// import store from '../vuex'
Vue.prototype.axios = axios

axios.defaults.baseURL = ''
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8'
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'
// axios.defaults.transformRequest = function (data) {
//   return (
//     Qs.stringify(data, { indices: false })
//   )
// }
axios.defaults.timeout = 20000

// 请求响应计数器
let requestNum = 0
let responseNum = 0

// axios请求拦截器
axios.interceptors.request.use(function (config) {
  if (config.params) {
  }
  requestNum++
  console.log('加载中')
  return config
}, function (error) {
  console.log('请求错误', error)
  return Promise.reject(error)
})

// axios响应拦截器
axios.interceptors.response.use(function (response) {
  responseNum++
  if (responseNum === requestNum) {
    setTimeout(() => {
      console.log('加载完毕')
    }, 500)
  }
  return response
}, function (error) {
  console.log('响应错误', error)
  return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./src/http/index.js